/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import HolderFirstName from './HolderFirstName/index'
import HolderLastName from './HolderLastName/index'
import React from 'react'
import ZipCode from './ZipCode/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Card({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Card"
  
}) {
  return (<React.Fragment
>
<HolderFirstName
  viewPath={`${viewPath}/HolderFirstName`}
/>
<HolderLastName
  viewPath={`${viewPath}/HolderLastName`}
/>
<ZipCode
  viewPath={`${viewPath}/ZipCode`}
/>
{children}
</React.Fragment>)
}